// @dynamic-i18n-keys
// deviationSubmit.form.app.oauth2RedirectWhitelist.hint.*
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import Textarea from '@wix/da-shared-react/pkg/Textarea';
import { useSubmitField } from '../../../hooks/useSubmitField';
import { OAuth2GrantType } from '../OAuthGrantTypeField';

import s from './OAuthRedirectUriField.scss';

const OAuthRedirectUriField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const {
    id,
    field: { onChange, value },
  } = useSubmitField('oauth2RedirectWhitelist', {
    initAdapter: ({ app }) => app?.oauth2RedirectWhitelist ?? '',
    submitAdapter: ({ oauth2RedirectWhitelist }) => ({
      oauth2_redirect_whitelist: oauth2RedirectWhitelist,
    }),
  });

  const { watch } = useFormContext();
  const grantType =
    watch('oauth2GrantType') ?? OAuth2GrantType.AUTHORIZATION_CODE;

  return (
    <Textarea
      id={id}
      label={t('deviationSubmit.form.app.oauth2RedirectWhitelist.label')}
      subLabel={t(
        `deviationSubmit.form.app.oauth2RedirectWhitelist.hint.${grantType}`
      )}
      onChange={onChange}
      value={value}
      textareaClassName={s['textarea']}
      isRequired
    />
  );
};
OAuthRedirectUriField.displayName = 'OAuthRedirectUriField';

export default OAuthRedirectUriField;
